import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useHideWhitePinsFeatureToggle } from '@/app/shared/hooks/useHideWhitePinsFeatureToggle';

import { useGetClustersQuery } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/query';
import { clustersSelector } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/selectors';
import { useMapConfigurationSelector } from '@/packages/redux-state/store/slices/mapConfiguration';
import { mapControlsActions } from '@/packages/redux-state/store/slices/mapControls';

export const useCurrentAreaSearchUpdateOnClustersChange = (): void => {
  const dispatch = useDispatch();

  const hideWhitePins = useHideWhitePinsFeatureToggle();

  const { initialized } = useMapConfigurationSelector();

  const {
    data: clusters,
    isFetching,
    isSuccess,
  } = useGetClustersQuery({ select: clustersSelector, enabled: initialized });

  useEffect(() => {
    if (isFetching || !isSuccess || hideWhitePins) {
      return;
    }

    /**
     * Активируется, когда в области видимости попадаются "белые точки"
     */
    const isCurrentAreaSearchActive = clusters.some(({ properties }) => !!properties?.outside);

    dispatch(mapControlsActions.setIsCurrentAreaSearchActive(isCurrentAreaSearchActive));
  }, [clusters, dispatch, hideWhitePins, isFetching, isSuccess]);
};
